import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'TableEmpty'
})
export default class TableEmpty extends Vue {
    @Prop({type: Array, default: () => []}) private items!: object[];
    @Prop(Array) private columnsItem!: string[];
    @Prop({type: String, default: 'No data available'}) private text!: string;

    private get notData() {
        return this.items.length === 0;
    }

    private get columns() {
        if(this.columnsItem){
            return this.columnsItem.length;
        } else {
            return 1;
        }
    }
}
